
import { defineComponent, computed, inject, ref, provide, watch } from 'vue'
import { AuthPlugin } from '@/auth'
import { useRoute, useRouter } from 'vue-router'
import ja from 'element-plus/es/locale/lang/ja'
import BaseFooter from '@/components/BaseFooter.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'

export default defineComponent({
  name: 'App',
  components: {
    BaseFooter,
    ImpersonationBanner
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const currentMenuIndex = ref('1')
    const idTokenClaims = ref()

    const auth: AuthPlugin | undefined = inject('Auth')
    if (!auth) {
      throw new Error('Auth plugin is not provided')
    }

    const handleMenuSelect = (key: string) => {
      if (key === '1') {
        router.push('/')
      } else if (key === '2') {
        router.push('/list')
      } else if (key === '3') {
        router.push('/setting')
      } else if (key === '4') {
        auth.logout({ returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI })
      }
    }

    const getIdToken = async () => {
      idTokenClaims.value = await auth.getIdTokenClaims({})
      console.log(idTokenClaims)
    }

    const isAdminUser = computed(() => {
      if (!idTokenClaims.value) return false
      
      // Auth0のroleベースの管理者判定
      const customRoles = idTokenClaims.value[`${process.env.VUE_APP_AUTH0_CLAIMS_NAMESPACE}/roles`]
      return customRoles && customRoles.includes('aimeat-admin')
    })

    // ルートが変更されたときにメニュー選択を更新
    watch(
      () => route.path,
      (path) => {
        if (path === '/') currentMenuIndex.value = '1'
        else if (path === '/list') currentMenuIndex.value = '2'
        else if (path === '/setting') currentMenuIndex.value = '3'
        else currentMenuIndex.value = ''  // Detail画面など、その他のパスの場合は選択を外す
      },
      { immediate: true }
    )

    ;(async () => {
      await getIdToken()
    })()

    provide('IsAdminUser', isAdminUser);

    const locale = ja

    return {
      auth,
      isAdminUser,
      handleMenuSelect,
      currentMenuIndex,
      locale,
    }
  },
})
